import { useEffect, useState } from 'react';
import './Home.css';
import './Login.css';
import  '../assets/css/dataTables.bootstrap4.min.css';
import './Modal.css';
import backgroundImage from '../assets/img/fondo-diseno.jpg';
import { useNavigate } from 'react-router-dom';

function AddUser() {
    const navigate = useNavigate();
const [isModalOpen, setIsModalOpen] = useState(false);
const [isModalOpen2, setIsModalOpen2] = useState(false);
const [totalUsers,setTotalUsers] = useState(0);
const[user,setUser]=useState('');
const[password,setPassword]=useState('');
const [data,setData] = useState([]);
const openModal = () => setIsModalOpen(true);
const closeModal = () => setIsModalOpen(false);
const openModal2 = () => setIsModalOpen2(true);
const closeModal2 = () => setIsModalOpen2(false);
const Login = async () => {
  console.log(user,password)
  fetch(`https://msensorapi.coolproyectdata.online/signup.php`, {
  method: "POST",
  headers: {
  Accept: "application/json",
  'Content-Type': 'application/x-www-form-urlencoded',
  },
  body:JSON.stringify({
  "email":user?.toLowerCase(),
  "password":password
  })
  })
  .then((response) => response.json())
  .then((responseData) => {
  console.log(JSON.stringify(responseData),"Login Result")
  //  
 
  if(responseData.status === 'Email Already Exists'){
  alert("Email Already Exists!");
  }else{
      alert("Added Successful!");
      closeModal()
      window.location.reload()
      //{"Customer_id":"2","status":"Login Successfully"}
  }
  })
  }
  const updatepassword = async () => {
    console.log(document.getElementById("cid-a30d").value,document.getElementById("username-a30d").value,password)
    fetch(`https://msensorapi.coolproyectdata.online/update.php`, {
    method: "POST",
    headers: {
    Accept: "application/json",
    'Content-Type': 'application/x-www-form-urlencoded',
    },
    body:JSON.stringify({
    "cid":document.getElementById("cid-a30d").value,
    "password":password
    })
    })
    .then((response) => response.json())
    .then(async(responseData) => {
    console.log(JSON.stringify(responseData),"Login Result")
    //  
   
    if(responseData.status === 'Password Updated Successfully'){
  
    const data = await fetch(`https://msensorapi.coolproyectdata.online/passwordemail.php?from=${password}&to=${document.getElementById("username-a30d").value}`, {
method: "POST",
mode:"no-cors",
headers: {
Accept: "application/json",
'Content-Type': 'application/json',
},
})
// .then((response) => response.json())
// .then((responseData) => {
console.log(data,"Result")
alert("Password Updated Successfully");
    closeModal()
    window.location.reload()
    }else{
        alert(responseData.status);
       
        //{"Customer_id":"2","status":"Login Successfully"}
    }
    })
    }

  const deleteuser = async(cid) =>{
    try {
        const response = await fetch(`https://msensorapi.coolproyectdata.online/signup.php?deletecid=${cid}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
  
        const responseData = await response.json();
        console.log(responseData);
        window.location.reload()
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}
    const getmac = async() =>{
        fetch('https://msensorapi.coolproyectdata.online/signup.php?getUsers=true',{
            method: "POST",
                   // crossorigin: true,    
                   // mode: 'no-cors', 
                    headers: {
                    Accept: "application/json",
                   "Content-Type": "application/json",

                    },
                 
                    })
      .then(response => response.json())
      .then(data => {
        console.log(data)
    setTotalUsers(data?.length)
    setData(data)
    }).catch(error=>{
        console.log(error)
    })
    }

    useEffect(()=>{

        const login = localStorage.getItem('cid');
        console.log(login,"cid")
        if( login === ''|| login === null || login === "null" || login === "undefined" || login === undefined || parseInt(parseInt(login?.slice(1,-1))) !== 6 || login?.slice(1,-1) !== "6"){

            navigate('/')
            }
            else{
              getmac()
            }
        },[])



return (
    <div className="u-body u-xl-mode"
    data-lang="en"  style={{ backgroundImage: `url(${backgroundImage})` }}>
        <header className="header">
          <div  onClick={()=>{openModal()}} style={{width:"140px",backgroundColor:"#fff",display:"flex",paddingLeft:"5px",justifyContent:"center",cursor:"pointer",
        alignItems:"center",boxShadow: '0 4px 2px rgba(0, 0, 60,0.2)',borderRadius:"5px"}}>
        <i style={{ padding: '5px 0', fontSize: '25px', color: '#007bff',alignSelf:"center",
      justifySelf:"center", }} className="fa fa-plus"></i><span style={{ paddingLeft:"10px",fontSize:'20px', color: '#007bff',alignSelf:"center",
      justifySelf:"center",fontWeight:"600px" }}>Add User</span>
      </div>
      <div className="header2">
            <img
                alt=""
                src={require('./images/right.png')}
                id="sg"
                onClick={() => {
                    localStorage.removeItem('cid');
                    navigate('/');
                }}
            />
            <span id="sp" style={{cursor:"pointer"}} onClick={() => {
                    localStorage.removeItem('cid');
                    navigate('/');
                }}>Sign Out</span>
                     </div>
        </header>
        
        <div style={{display:"flex",flexDirection:"row",width: '98%',fontSize:"20px",}}>
        <div style={{color:"#fff",textAlign:"left",alignSelf:"flex-start",marginLeft:"1%"}}>
         Existing Total Users:</div>
          <div style={{color:"#fff",textAlign:"left",alignSelf:"flex-start",marginLeft:"1%",fontWeight:"600"}}>{totalUsers}</div>
        </div>
        
        <div style={{ width: '100%', maxHeight: '560px',padding:"20px"}}>
        <div
        
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '20px',
          
            border: '0px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#007bff',
            boxShadow: '0 4px 2px rgba(0, 0, 60,0.2)',
           // transition: 'transform 0.3s ease',
            fontWeight:"600"
          }}
          // onMouseEnter={(e) => {e.currentTarget.style.transform = 'scale(1.05)';
          // e.currentTarget.style.backgroundColor = '#fdfdfd';}}
          // onMouseLeave={(e) => {e.currentTarget.style.transform = 'scale(1)';
          // e.currentTarget.style.backgroundColor = '#fff'}}
        >
          <div style={{ flex: '1', paddingRight: '20px',width:"30px",overflow:"hidden" }}>
            <h3 style={{ margin: '0', fontSize: '1rem', color: '#fff',fontWeight:"600" }}>Customer ID</h3>
      
          </div>
          <div style={{ flex: '1', paddingRight: '20px',width:"10px",overflow:"hidden" }}>
            <h3 style={{ margin: '0', fontSize: '1rem', color: '#fff',fontWeight:"600" }}>Email</h3>
          </div>
          <div style={{ flex: '1', paddingRight: '20px',width:"20px",overflow:"hidden" }}>
            <h3 style={{ margin: '0', fontSize: '1rem', color: '#fff',fontWeight:"600" }}>Password</h3>
          </div>
          <div  style={{ flex: '1',cursor:"pointer" , paddingRight: '20px',width:"20px",overflow:"hidden" }}>
            <h3 style={{ margin: '0', fontSize: '1rem', color: '#fff',fontWeight:"600" }}>Delete</h3>
          </div>
          <div  style={{ flex: '1',cursor:"pointer" , paddingRight: '20px',width:"20px",overflow:"hidden" }}>
            <h3 style={{ margin: '0', fontSize: '1rem', color: '#fff',fontWeight:"600" }}>Edit</h3>
          </div>
        </div>
        <div   className="table-responsive"
    style={{ maxHeight: "560px", overflowY: "auto" }} >
      {data?.map((item, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '20px',
            margin: '10px 0',
            border: '1px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 2px rgba(0, 0, 60,0.2)',
            transition: 'transform 0.3s ease',
            fontWeight:"600",
            fontFamily:""
          }}
          onMouseEnter={(e) => {e.currentTarget.style.transform = 'scale(1.02)';
          e.currentTarget.style.backgroundColor = '#fdfdfd';}}
          onMouseLeave={(e) => {e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.backgroundColor = '#fff'}}
        >
          <div style={{ flex: '1', paddingRight: '20px',width:"20px",overflow:"hidden"}}>
            <p style={{ margin: '5px 0', fontSize: '16px', color: '#555' }}>{item?.customer_id}</p>
          </div>
          <div style={{ flex: '1', paddingRight: '30px',width:"20px",overflow:"hidden" }}>
            <p style={{ margin: '5px 0', fontSize: '16px', color: '#007bff' }}>{item?.email}</p>
          </div>
          <div style={{ flex: '1' ,width:"30px",overflow:"hidden", paddingRight: '20px' }}>
            <p style={{ margin: '5px 0', fontSize: '16px', color: '#555' }}>{item?.password}</p>
          </div>
          <div onClick={()=>deleteuser(item?.customer_id)} style={{ flex: '1',cursor:"pointer",width:"20px",overflow:"hidden", paddingRight: '20px'  }}>
            <i style={{ margin: '5px 0', fontSize: '20px', color: '#555' }} className="fa fa-trash"></i>
          </div>
          <div onClick={()=>{openModal2();setTimeout(() => {
            document.getElementById("username-a30d").value = item?.email
            document.getElementById("cid-a30d").value = item?.customer_id
          }, 400); }} style={{ flex: '1',cursor:"pointer",width:"20px",overflow:"hidden" , paddingRight: '20px' }}>
            <i style={{ margin: '5px 0', fontSize: '22px', color: '#555' }} className="fa fa-edit"></i>
          </div>
        </div>
      ))}
      </div>
    </div>

    {isModalOpen && (
<div style={overlayStyle} onClick={closeModal}>
<div
style={modalStyle}
onClick={(e) => e.stopPropagation()}>
<div  onClick={closeModal} style={closeButtonStyle}>
&times;
</div>

<section style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}  id="sec-5b86">
        <div style={{width:"500px",display:"flex",alignItems:"center",justifyContent:"center"}} >
          <div
            style={{
              backgroundColor: "rgba(102, 16, 242, 0.0)",
              width:"100%",alignSelf:"center"
            }}
            className="u-align-center u-container-style u-expanded-width-xs u-grey-90 u-group u-radius-5 u-shape-round u-group-1"
          >
            <div
              style={{
                backgroundColor: "rgba(102, 16, 242, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                padding: "20px",
              }}
              className="u-container-layout u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xl u-container-layout-1"
            >
              {/* Logo Section */}
              <div
                style={{
                  backgroundColor: "rgba(62, 16, 242, 0.5)",
                  width: "170px",
                  height: "140px",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  border: "3px solid rgba(120, 150, 202, 0.8)",
                  borderRadius: "7px",
                }}
              >
                <img
                  alt=""
                  src={require("../assets/img/logo.png")}
                  style={{
                    width: "160px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />
              </div>
 
              {/* Login Form */}
              <div className="u-form u-login-control " style={{ width: "100%", maxWidth: "400px" }}>
                {/* Email Input */}
                <div style={{color:"#fff",fontWeight:"700",fontSize:"50px",}}>ADD USER</div>
                <div className="u-form-group u-form-name u-label-top mt-3">
                <img
                  alt=""
                  src={require("../assets/img/user.png")}
                  style={{
                    width: "37px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />Email
                  <input
                    type="text"
                    placeholder="Enter your Email"
                    id="username-a30d"
                    name="email"
                    className="u-border-8 u-border-white mt-1 u-input u-input-rectangle u-radius-4 u-white u-input-2"
                    onChange={(e) => setUser(e.target.value)}
                    required=""
                    style={{ width: "100%" }}
                  />
                </div>
  
                {/* Password Input */}
                <div className="u-form-group u-form-password u-label-top mt-3">
                <img
                  alt=""
                  src={require("../assets/img/key.png")}
                  style={{
                    width: "32px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />  Password
                  <input
                    type="text"
                    placeholder="Enter your Password"
                    id="password-a30d"
                    name="password"
                    className="u-border-8 u-border-white mt-2 u-input u-input-rectangle u-radius-4 u-white u-input-2"
                    onChange={(e) => setPassword(e.target.value)}
                    required=""
                    style={{ width: "100%" }}
                  />
                </div>
  
                {/* Login Button with Row Layout */}
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "15%",
                  }}
                  className="u-align-center u-form-group u-form-submit u-label-top"
                >
                  <button
                    onClick={() => Login()}
                    className="u-border-none mt-3   u-radius-4  "
                    style={{
                      border: "none",
                      width: "30%",
                      fontWeight: "700",
                      height: "50px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      backgroundColor: "#007bff",
                      padding: "0px",
                    }}
                  >
                    Add
                  </button>
                
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </section>

</div>
</div>
)}


{isModalOpen2 && (
<div style={overlayStyle} onClick={closeModal2}>
<div
style={modalStyle}
onClick={(e) => e.stopPropagation()}>
<div  onClick={closeModal2} style={closeButtonStyle}>
&times;
</div>

<section style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}  id="sec-5b86">
        <div style={{width:"500px",display:"flex",alignItems:"center",justifyContent:"center"}} >
          <div
            style={{
              backgroundColor: "rgba(102, 16, 242, 0.0)",
              width:"100%",alignSelf:"center"
            }}
            className="u-align-center u-container-style u-expanded-width-xs u-grey-90 u-group u-radius-5 u-shape-round u-group-1"
          >
            <div
              style={{
                backgroundColor: "rgba(102, 16, 242, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                padding: "20px",
              }}
              className="u-container-layout u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xl u-container-layout-1"
            >
              {/* Logo Section */}
              <div
                style={{
                  backgroundColor: "rgba(62, 16, 242, 0.5)",
                  width: "170px",
                  height: "140px",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  border: "3px solid rgba(120, 150, 202, 0.8)",
                  borderRadius: "7px",
                }}
              >
                <img
                  alt=""
                  src={require("../assets/img/logo.png")}
                  style={{
                    width: "160px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />
              </div>
 
              {/* Login Form */}
              <div className="u-form u-login-control " style={{ width: "100%", maxWidth: "400px" }}>
                {/* Email Input */}
                <div style={{color:"#fff",fontWeight:"700",fontSize:"30px",}}>CHANGE PASSWORD</div>
                <div className="u-form-group u-form-name u-label-top mt-3">
                <img
                  alt=""
                  src={require("../assets/img/user.png")}
                  style={{
                    width: "37px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />Email
                  <input
                  disabled
                    type="text"
                    placeholder="Enter your Email"
                    id="username-a30d"
                    name="email"
                    className="u-border-8 u-border-white mt-1 u-input u-input-rectangle u-radius-4 u-white u-input-2"
                    onChange={(e) => setUser(e.target.value)}
                    required=""
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="u-form-group u-form-name u-label-top mt-3">
            
                  <input
                  disabled
                    type="hidden"
                    placeholder="Enter your Email"
                    id="cid-a30d"
                    name="email"
                    className="u-border-8 u-border-white mt-1 u-input u-input-rectangle u-radius-4 u-white u-input-2"
                    onChange={(e) => setUser(e.target.value)}
                    required=""
                    style={{ width: "100%" }}
                  />
                </div>
                {/* Password Input */}
                <div className="u-form-group u-form-password u-label-top mt-3">
                <img
                  alt=""
                  src={require("../assets/img/key.png")}
                  style={{
                    width: "32px",
                    alignSelf: "center",
                    verticalAlign: "center",
                  }}
                />  Password
                  <input
                    type="text"
                    placeholder="Enter your Password"
                    id="password-a30d"
                    name="password"
                    className="u-border-8 u-border-white mt-2 u-input u-input-rectangle u-radius-4 u-white u-input-2"
                    onChange={(e) => setPassword(e.target.value)}
                    required=""
                    style={{ width: "100%" }}
                  />
                </div>
  
                {/* Login Button with Row Layout */}
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "15%",
                  }}
                  className="u-align-center u-form-group u-form-submit u-label-top"
                >
                  <button
                    onClick={() => updatepassword()}
                    className="u-border-none mt-3   u-radius-4  "
                    style={{
                      border: "none",
                      width: "30%",
                      fontWeight: "700",
                      height: "50px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                      backgroundColor: "#007bff",
                      padding: "0px",
                    }}
                  >
                    Update
                  </button>
                
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </section>

</div>
</div>
)}
    </div>
);
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
  };
  const closeButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "transparent",
  border: "none",
  fontSize: "2.5rem",
  cursor: "pointer",
  color:"#fff"
  };
  const modalStyle = {
  // backgroundColor: "#fff",

backgroundImage: `url(${backgroundImage})`,
  padding: "20px",
  maxHeight:"620px",
  borderRadius: "8px",
  width: "90%", // Reduce width for responsiveness
  maxWidth: "800px", // Limit max-width
  textAlign: "center",
  position: "relative",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  };

export default AddUser;




//Msensor1
//msensor